import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {GlobalService} from 'app/global/global.service';
import {updateValue} from 'app/global/synchronize';
import {Field} from 'app/interfaces/fields';
import {GeneralPopoverSettingsComponent} from '../../general-popover-settings/general-popover-settings.component';
import { SelectedRole } from '../../general-popover-settings/general-popover-settings.dto';

@Component({
  selector: 'app-assign-role',
  templateUrl: './assign-role.component.html',
  styleUrl: './assign-role.component.scss',
  providers: [GeneralPopoverSettingsComponent]
})
export class AssignRoleComponent implements OnInit {
  @Input() fields: Array<Field>
  constructor(
    public modal: NgbActiveModal,
    public generalPopoverSettings: GeneralPopoverSettingsComponent,
    private globalService: GlobalService,
  ) { }
  public selectedRole:number = null;
  async ngOnInit() {
    await this.generalPopoverSettings.setupAllFields();
    this.generalPopoverSettings.selectRole = this.generalPopoverSettings.selectRole.filter((role:SelectedRole) => (role?.id != -1 && role?.id != 0));
  }

  assignTheSelectedRole() {
    for (const field of this.fields) {
      const fieldData: Field = { ...field };
      fieldData.selected_for_role_id = this.selectedRole;

      const updateFieldData = (role, roleField) => {
        const customField = {...role[roleField].find(item => item.key === fieldData?.content_library_selected_field_type)};
        if (Object.keys(customField).length > 0) {
          fieldData.selected_field_type_id = fieldData.prefixid = customField.id;
          if (role.recipient_id) {
            if(customField.key === 'first_name'){
                customField.value = `${role.recipient.firstname} ${role.recipient.lastname ?? ''}`
            }
            updateValue(fieldData.uuid, customField.value, this.globalService);
          }
        }
      };

      const updateRoleAndField = (roleField) => {
        const role = this.globalService.roles.find(role => role.role_name === fieldData.selected_field_role_id)
          || this.globalService.roles.find(role => role.id === this.selectedRole);
        if (role) {
          fieldData.selected_field_role_id = role.id;
          updateFieldData(role, roleField);
        }
      };

      if (fieldData.field_section === "person_field") {
        updateRoleAndField('personfields');
      }

      if (fieldData.field_section === "org_field") {
        updateRoleAndField('orgfields');
      }
      this.globalService.fields_data[fieldData.uuid] = fieldData;
      this.modal.close();
    }
  }
}
